import Type from './Type';
export class DiscourseStatement {
    constructor({statement, factory}) {
        this.type = Type.Statement;
        this.statement = factory(statement);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.writable = false;
        descriptors.type.configurable = false;
        descriptors.statement.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export const klass = DiscourseStatement;
export {
    DiscourseStatement as Statement
};
export default DiscourseStatement;    //# sourceMappingURL=Statement.js.map
